import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[#EBE2E8] bg-white" data-testid="main-footer">
      <div className="container-x py-14 grid md:grid-cols-3 gap-10">
        <div className="max-w-sm">
          <Logo size={40} wordmarkClass="text-xl" />
          <p className="mt-4 font-manrope text-sm text-ink-soft leading-relaxed">
            A registry for hysterectomy recovery — built with tenderness, by and for women taking
            control of their healing.
          </p>
        </div>
        <div>
          <h4 className="font-outfit text-sm font-medium text-ink uppercase tracking-wider">Product</h4>
          <div className="mt-4 flex flex-col gap-2 font-manrope text-sm text-ink-soft">
            <Link to="/browse" className="hover:text-brand transition-colors" data-testid="footer-browse">Browse items</Link>
            <Link to="/register" className="hover:text-brand transition-colors" data-testid="footer-register">Start a registry</Link>
            <Link to="/login" className="hover:text-brand transition-colors" data-testid="footer-login">Log in</Link>
          </div>
        </div>
        <div>
          <h4 className="font-outfit text-sm font-medium text-ink uppercase tracking-wider">Learn</h4>
          <div className="mt-4 flex flex-col gap-2 font-manrope text-sm text-ink-soft">
            <Link to="/blog" className="hover:text-brand transition-colors" data-testid="footer-blog">Blog</Link>
            <Link to="/" className="hover:text-brand transition-colors" data-testid="footer-home">About</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-[#EBE2E8]">
        <div className="container-x py-5 text-xs font-manrope text-ink-soft text-center">
          © {new Date().getFullYear()} Hysteregistry · Made with care.
        </div>
      </div>
    </footer>
  );
}
